exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ChevronArrow-module__arrow___2t5Yu{justify-content:flex-end;cursor:pointer}", ""]);

// exports
exports.locals = {
	"arrow": "ChevronArrow-module__arrow___2t5Yu"
};